import { render, staticRenderFns } from "./taskComplete.vue?vue&type=template&id=004ba66e&scoped=true"
import script from "./taskComplete.vue?vue&type=script&lang=js"
export * from "./taskComplete.vue?vue&type=script&lang=js"
import style0 from "./taskComplete.vue?vue&type=style&index=0&id=004ba66e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004ba66e",
  null
  
)

export default component.exports